// export const BASE_URL = 'https://localhost:3000/api/';
export const CASES_ROUTE = 'cases';
export const EVENTS_ROUTE = 'events';
export const INVITES_ROUTE = 'invites';
export const CALENDAR_POST_URL = 'cases/{0}/events';
export const PATIENTS_ROUTE = 'patients';
export const FILES_ROUTE = 'files';
export const NOTIFICATIONS_ROUTE = 'notifications';
export const ROLES_ROUTE = 'roles';
export const USERS_ROUTE = 'users';
export const USER_ROLES_ROUTE = 'user/role';
export const INVITE_STAFF_ROUTE = 'invites/addStaff';
export const EMPLOYERS_ROUTE = 'employers';
export const OCC_HEALTH_ROUTE = 'occ-health';
export const MED_RECRUITER_ROUTE = 'med-recruiter';

export const TOS_URL = 'https://getoutpatient.com/terms/';
export const PRIVACY_POLICY_URL = 'https://www.iubenda.com/privacy-policy/97781015/full-legal';
export const PRIVACY_STATEMENT_URL = 'https://getoutpatient.com/terms/';
